import React, { useState, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from '@mui/material';
import Loading from '../components/loading';
import ErrorMessage from '../components/errorMessage';
import { useSaveClinicNotification } from './hooks/useSaveClinicNotification';

export default function NotificationModal({ open, onClose, onSaveSuccess }) {
  const { save: saveNotificationRequest } = useSaveClinicNotification();
  const [isLoading, setLoading] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [description, setDescription] = useState('');

  useEffect(() => {
    if (open) {
      cleanFields();
      setShowErrorMessage(false);
      setLoading(false);
    }
  }, [open]);

  const saveNotification = (event) => {
    event.preventDefault();

    if (!description.trim()) {
      setShowErrorMessage(true);
      setErrorMessage('Todos os campos são obrigatórios!');
      return;
    }

    const notificationData = {
      description: description,
    };

    setLoading(true);
    saveNotificationRequest(notificationData)
      .then((returnFromApi) => {
        onSaveSuccess(returnFromApi);
        cleanFields();
        setLoading(false);
      })
      .catch((returnFromApi) => {
        setShowErrorMessage(true);
        setErrorMessage(returnFromApi.response?.data);
        console.error('Erro ao salvar notificação:', returnFromApi);
        setLoading(false);
      });
  };

  function cleanFields() {
    setDescription('');
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Loading isToHidden={isLoading === false} />
      {showErrorMessage && (
        <ErrorMessage
          message={errorMessage}
          show={showErrorMessage}
          setShow={setShowErrorMessage}
        />
      )}

      <DialogTitle>Nova Notificação</DialogTitle>

      <DialogContent dividers>
        <form id="new-notification-form" onSubmit={saveNotification}>
          <Grid container spacing={3}>
            <Grid size={12}>
              <TextField
                fullWidth
                label="Descrição"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                variant="outlined"
                multiline
                rows={4}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          Cancelar
        </Button>
        <Button type="submit" form="new-notification-form" variant="contained" disabled={isLoading}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
